import { defineChannel, type ChannelDefinition } from '../channel-definition';

export const liveNotificationChannel = defineChannel({
  id: 'live_notification',
  icon: 'mobile',
  name: 'Live notification',
  shortName: 'live notification',
  noun: 'live notification',
  events: ['attempted', 'sent', 'delivered', 'failed', 'bounced', 'opened', 'undeliverable'],
  deliveryStates: ['attempted', 'sent', 'failed', 'bounced', 'suppressed', 'undeliverable', 'holdout', 'delivered'],
  deliveryActions: ['opened', 'converted'],
} as const satisfies ChannelDefinition);
